import {combineReducers} from 'redux';
import Const from 'constants';
import {createOverallFilterPosition} from 'components/organisms/filter-by-position/filter-position-interface';

const defaultStateOfFilters = {
    position: createOverallFilterPosition(),
    tier: Const.PLAYERS_TIERS_FILTER_ALL,
    showDown: Const.PLAYERS_SHOWDOWN_FILTER_ALL,
    singleGame: Const.PLAYERS_SINGLEGAME_FILTER_ALL,
    showUnexposedPlayersEnabled: false,
    isShowUnexposedPlayersEnabled() {
        return this.showUnexposedPlayersEnabled;
    },
};

export function filters(state = defaultStateOfFilters, action) {
    state = {...state};

    if (action.type === Const.USED_PLAYERS_SET_FILTER_POSITION) {
        state.position = action.value;
    } else if (action.type === Const.USED_PLAYERS_SET_FILTER_TIER) {
        state.tier = action.value;
    } else if (action.type === Const.USED_PLAYERS_SET_FILTER_SHOWDOWN) {
        state.showDown = action.value;
    } else if (action.type === Const.USED_PLAYERS_SET_FILTER_SINGLE_GAME) {
        state.singleGame = action.value;
    } else if (action.type === Const.SHOW_UNEXPOSED_PLAYERS_IN_EXPOSURE_BOX) {
        state.showUnexposedPlayersEnabled = action.checked;
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.RESET_LINEUP_PLAYER_FILTER])) {
        state = {...defaultStateOfFilters};
    }

    return state;
}

const defaultStateOfPlayers = {
    data: [],
    all() {
        return [...this.data];
    },
    getPlayers(playerId) {
        playerId = String(playerId);

        return this.all().filter((player) => String(player.getId()) === playerId);
    },
    getExposedPlayers() {
        return this.all().filter((player) => player.usedLineupsCount > 0);
    },
};

export function players(state = defaultStateOfPlayers, action) {
    state = {...state};

    if (action.type === Const.SET_LINEUPS_USED_PLAYERS) {
        state.data = action.data;
    } else if (action.type === Const.UNSET_LINEUPS) {
        state.data = [];
    }

    return state;
}

const reducers = {
    filters,
    players,
};

export default combineReducers(reducers);
